export default "__VITE_ASSET__oxB3zUEx__"